<div class="container-fluid">
  <div class="container">
    <div class="col-lg-12 col-md-12 mt-md-5">
      <div>
        <button (click)="openAddModal()" type="button" class="btn btn-primary" data-bs-toggle="modal"
          data-bs-target="#exampleModal">
          Create New Ads
        </button>
      </div>
      <div class="row">
        <div class="col-sm-4" *ngFor="let data of adsData">
          <div class="card mt-3 position-relative" style="width: 18rem">
            <button type="button"
              class="btn btn-light text-danger position-absolute top-0 end-0 m-2 rounded-circle shadow-sm"
              style="width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center;"
              (click)="displayAd(data.id, false)">
              <i class="fa fa-trash"></i>
            </button>
            <img class="card-img-top" style="max-height: 200px" [src]="getFileUrl(data.fileId)" [alt]="data.fileId" />
            <div class="card-body">
              <h5 class="card-title">{{ data.title }}</h5>
              <p class="card-text">{{ data.poi }}</p>
              <p *ngIf="data.startDate" class="card-text">
                Start Date : <span>{{ data.startDate }}</span>
              </p>
              <p *ngIf="data.endDate" class="card-text">
                End Date : <span>{{ data.endDate }}</span>
              </p>
              <div class="d-flex justify-content-between">
                <button type="button" class="btn btn-primary" (click)="publishAd(data.id, data.published)">
                  {{ data.published ? "UnPublish" : "Publish" }}
                </button>
                <!-- (click)="displayAd(data.id)" -->
                <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal"
                  (click)="editAd(data)">
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header border-bottom p-2">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                {{ isEditMode ? "Edit" : "Create New" }} ADS
              </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #closeBtn></button>
            </div>
            <div class="modal-body p-2">
              <form class="example-form" [formGroup]="adsForm" (ngSubmit)="submitForm()">
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>Ads Title</mat-label>
                    <input matInput placeholder="Ads Title" formControlName="adTitle" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Ads Type</mat-label>
                    <mat-select (selectionChange)="onAdTypeChange($event)" formControlName="adType">
                      <mat-option value="1">Mkm</mat-option>
                      <mat-option value="2">Tzadikim</mat-option>
                      <mat-option value="3">OutsideLink</mat-option>
                      <mat-option value="4">Image</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type">
                      <mat-option value="Completed">Completed</mat-option>
                      <mat-option value="Current">Current</mat-option>
                      <mat-option value="Upcoming">Upcoming</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="d-flex">
                    <mat-form-field appearance="outline" class="me-2">
                      <mat-label>Start Date</mat-label>
                      <input matInput [matDatepicker]="startpicker" formControlName="startDate" />
                      <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                      <mat-datepicker #startpicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>End Date</mat-label>
                      <input matInput [matDatepicker]="endpicker" formControlName="endDate" />
                      <mat-datepicker-toggle matIconSuffix [for]="endpicker"></mat-datepicker-toggle>
                      <mat-datepicker #endpicker></mat-datepicker>
                    </mat-form-field>
                  </div>

                  <mat-form-field appearance="outline" *ngIf="showMkmInput">
                    <mat-label>Places</mat-label>
                    <input type="text" placeholder="places" aria-label="places" matInput (keyup)="onchange($event)"
                      formControlName="mkmId" [matAutocomplete]="auto" />
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filteredOptions" [value]="option.id">{{ option.mkmTitle
                        }}</mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field appearance="outline" *ngIf="showTzadikimInput">
                    <mat-label>צדיקים</mat-label>
                    <input type="text" placeholder="צדיקים" aria-label="צדיקים" matInput (keyup)="onchange($event)"
                      formControlName="mkmId" [matAutocomplete]="auto" />
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filteredOptions" [value]="option.mkmId">{{ option.subTitle
                        }}</mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field appearance="outline" *ngIf="showAdUrlInput">
                    <mat-label>Ads Url</mat-label>
                    <input matInput placeholder="Ads Url" formControlName="adUrl" />
                  </mat-form-field>

                  <div class="mb-3" *ngIf="showFirstUpload">
                    <label for="fileUpload" class="form-label">Upload File</label>
                    <input type="file" class="form-control" id="adTitle" (change)="handleOnChange($event, 1)" />
                  </div>
                  <div class="mb-3" *ngIf="showSecondUpload">
                    <label for="fileUpload" class="form-label">Upload File</label>
                    <input type="file" class="form-control" id="fileUpload" (change)="handleOnChange($event, 2)" />
                    <div *ngIf="adsForm.value.adType == '4' && adsForm.value.fileName" class="mt-2">
                      <small class="text-muted">Existing file: {{ adsForm.value.fileName }}</small>
                    </div>
                  </div>
                  <div class="mt-2">
                    <button type="button" class="addImage-btn btn" *ngIf="!showSecondUpload"
                      (click)="showSecondUpload = true">
                      + Add Another Image
                    </button>

                    <button type="button" class="btn remove-btn" *ngIf="showSecondUpload" (click)="removeSecondImage()">
                      Remove Second Image
                    </button>
                  </div>
                  <div class="mb-2 d-flex flex-column" *ngIf="fileImageUrl">
                    <label for="showImage" class="form-label">Image</label>
                    <div class="d-flex">
                      <img *ngIf="fileImageUrl" [src]="fileImageUrl" alt="image" style="width: 100px;height: 100px;">
                      <img *ngIf="fileImageUrl2" [src]="fileImageUrl2" alt="image" class="ms-2"
                        style="width: 100px;height: 100px;">
                    </div>
                  </div>

                  <!-- <div class="mb-3" >
                    <label class="form-label">Image</label>


                    <div class="mb-2">
                      <img alt="image" style="width:100px; height:100px; object-fit:cover;">
                    </div>

                    <div class="mb-2" *ngIf="adsForm.value.adType == '4'">
                      <small class="text-muted">Existing file: </small>
                    </div>

                    <input type="file" class="form-control" (change)="handleOnChange($event)" accept="image/*" />

                    <div class="mt-2">
                      <button type="button" class="btn btn-outline-primary btn-sm" (click)="addImageSlot()">
                        + Add Another Image
                      </button>
                    </div>

                    <div class="mt-2">
                      <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeImageSlot(1)">
                        Remove
                      </button>
                    </div>
                  </div> -->
                  <!-- ===== End multiple image uploads ===== -->

                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button type="button" (click)="submitForm()" class="btn btn-primary">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>